import { fmtDT } from "@/lib/format";

export function OrderAuditTable({ entries }) {
  return (
    <div className="bg-card border border-border rounded-lg overflow-x-auto">
      <h2 className="text-xl font-bold uppercase tracking-tight px-5 pt-4">Audit Trail</h2>
      <table className="w-full text-sm mt-2" data-testid="order-audit-table">
        <thead>
          <tr className="border-b border-border text-left">
            {["Time", "User", "Action"].map((h) => (
              <th key={h} className="px-4 py-2 text-[10px] font-mono uppercase tracking-widest text-muted-foreground">{h}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {(entries || []).map((a, i) => (
            <tr key={`${a.at}-${a.user_name}-${a.action}`} className="border-b border-border/50" data-testid={`audit-row-${i}`}>
              <td className="px-4 py-2 metric text-xs whitespace-nowrap">{fmtDT(a.at)}</td>
              <td className="px-4 py-2">{a.user_name}</td>
              <td className="px-4 py-2">{a.action}</td>
            </tr>
          ))}
          {(entries || []).length === 0 && <tr><td colSpan={3} className="px-4 py-6 text-center text-muted-foreground">No audit entries</td></tr>}
        </tbody>
      </table>
    </div>
  );
}
